enum AnalyticsSpecialNumberFormatting {
  InExperienceCurrency = 'inExperienceCurrency',
}

export default AnalyticsSpecialNumberFormatting;
